import { isString } from 'lodash';
import { NavigationGuard, RouteLocationRaw } from 'vue-router';

import { OrderStep } from '@/constants/order/constants';
import { globalActions } from '@/store/modules/global';
import { orderActions, orderGetters } from '@/store/modules/order';

async function getOrder(id: string) {
	if (!orderGetters.getOrderByGuid()(id)) {
		await globalActions.addGlobalLoader(() => orderActions.fetchOrderByGuid(id));
	}

	return orderGetters.getOrderByGuid()(id);
}

export const orderScanDynamicRedirect: NavigationGuard = async (to, from, next) => {
	const { orderGuid } = to.params;
	const order = await getOrder(isString(orderGuid) ? orderGuid : orderGuid[0]);

	if (!order) {
		throw new Error(`Order not found for "${orderGuid}"`);
	}

	const overrideTo: RouteLocationRaw = {
		params: { orderGuid },
	};

	overrideTo.name = OrderStep.AfterConfirmation;

	next(overrideTo);
};
